import GET_INSTAGRAM from '../plugins/getInstagram'

const [ w, l ] = [ window, location ]

const init = () => {

  if( w.load['loadHtml'] ){
    $.when( w.load['products01'], w.load['products02'], w.load['products03'] ).done( () => {
      GET_INSTAGRAM()
    });
  }

}

export default function PRODUCTS() {
  $( init )
}